import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

export default function LandingCard ( {title, description, img_src, link=""}  ) { 
    const navigate = useNavigate();
    let showButton = true;
    if(link === "") {
        showButton = false;
    }

    const onGoTo = () => {
        navigate(link);
    }

return (
 <Container>
    <div className="info-container">
        <img src={img_src} />
        <div className="text-box">
            <h2> {title} </h2>
            <ul style={{ listStyleType: 'disc' }}>
                {description.map((item, i) => {
                    return <li key={i}> {item} </li>
                })}  
            </ul>
        </div>    
        {showButton && ( 
            <button onClick={onGoTo}> View more </button>        
        )}
    </div>    
 </Container>
)
}

const Container = styled.div`
max-width: 400px;
width: 400px;
height: 420;
position: relative;
color: black;
background: white;
border-radius: 5px;
box-shadow: rgba(0, 0, 0, 0.75) 0px 3px 10px;
gap: 2rem;
.info-container {
    display: flex;  
    flex-direction: column;
    gap: 2rem;    
    justify-content: center;
    text-align: center;
    padding: 1rem;
    img {
        width: 100%;
        height: 200px;
        border-radius: 5px;
    }
    .text-box {        
        display: flex;  
        flex-direction: column;
        gap: 0.5rem; 
        padding: 0rem 1.5rem;
        ul {
            text-align: left;
        }
    }
    button {
        padding: 0.5rem 1rem;
        background-color: #E55B41;
        border: none;
        cursor: pointer;
        color: white;
        border-radius: 0.2rem;
        font-weight: bolder;
        font-size: 1.05rem;            
        a {
            color: white;
        }
    }
}

`;
